import { App } from 'vue';
import { IgcModalService } from './IgcModalService';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $igcModal: IgcModalService;
  }
}

export const ModalPlugin = {
  install: (app: App, options: any) => {
    app.config.globalProperties.$igcModal = new IgcModalService();
  },
};
